import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, auth } from "@/lib/api";
import Navbar from "@/components/Navbar";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      auth.setSession(data.token, data.user);
      toast.success("Welcome back");
      nav("/discover");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="font-mono text-xs uppercase tracking-widest text-[#555] mb-3">[ AUTH / LOGIN ]</div>
        <h1 className="font-display text-5xl tracking-tighter mb-8">Log<br />back<br />in.</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="font-mono text-xs uppercase block mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-3 py-3 bg-white border border-black focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>
          <div>
            <label className="font-mono text-xs uppercase block mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-3 bg-white border border-black focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>
          <button
            data-testid="login-submit"
            disabled={loading}
            className="w-full py-4 bg-[#E53935] hover:bg-[#C62828] text-white font-mono disabled:opacity-60"
          >
            {loading ? "ENTERING..." : "ENTER →"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#555]">
          No account? <Link to="/signup" data-testid="login-to-signup" className="underline">Join FaceMatch</Link>
        </p>
      </div>
    </div>
  );
}
